import { useNavigate } from 'react-router-dom';

import { LinkItem } from '@occc/ui-design-system';
import { useOpenState } from '@occc-app/hooks/useOpenState';
import { useGetGeneralSurveyById } from '@occc-app/dataAccessLayer/survey/queries';
import { useChainId } from '@occc-app/Chain/hooks';

import { useGetFormContainerProps } from './useGetFormContainerProps';

import { routeCreator } from '../routeCreator';
import { useGetAudienceById } from '../../../dataAccessLayer/audience/useGetAudienceById';

type GetContainerPropsArgs = {
  surveyId?: string;
  getBreadcrumbLinks: (surveyName: string) => LinkItem[];
};

export const useGetContainerProps = ({ surveyId, getBreadcrumbLinks }: GetContainerPropsArgs) => {
  const navigate = useNavigate();
  const chainId = useChainId();
  const [open, openModal, closeModal] = useOpenState();

  const redirectToGeneralSurveysList = () => {
    navigate(routeCreator.list());
  };

  const handleCancelClick = (hasUnsavedChanges: boolean) => {
    hasUnsavedChanges ? openModal() : redirectToGeneralSurveysList();
  };

  const surveyResponse = useGetGeneralSurveyById({ variables: { uuid: surveyId || '' } });
  const { survey, loading: surveyLoading } = surveyResponse;

  const { data: audience, loading: audienceLoading } = useGetAudienceById(
    survey?.audienceUuid,
    chainId,
  );
  const surveyDetailsRoute = routeCreator.details(surveyId || '');

  const dialogProps = {
    open,
    closeModal,
    title: 'General Survey',
    onConfirmClick: redirectToGeneralSurveysList,
  };

  const { layoutProps, configureFormProps, targetFormProps, scheduleFormProps } =
    useGetFormContainerProps({
      surveyDetailsRoute,
      onCancel: handleCancelClick,
      survey,
      loading: surveyLoading || audienceLoading,
      chainId,
      audience,
    });

  return {
    layoutProps,
    dialogProps,
    configureFormProps,
    targetFormProps,
    scheduleFormProps,
    breadcrumbLinks: getBreadcrumbLinks(survey?.name || ''),
  };
};
